export const spacing = {
  xxxl: 60,
  xxl: 50,
  xl: 40,
  lg: 30,
  md: 20,
  sm: 10,
  xs: 5,
}
